module.exports = __webpack_public_path__ + "static/scale-model-of-luis-maria-peralta-adobe-in-san-jose-california-66fc54ab22dcdce5bb1ea3c07f7fd06f.png";